import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface StaffDateOfBirthStatus {
  /** true = this staff member must enter their date of birth before using the Board. */
  required: boolean;
  /** 'YYYY-MM-DD' or null. */
  dateOfBirth: string | null;
}

/**
 * Staff date of birth (Oct 2026): every Board user except Entity Owners enters
 * it once; afterwards only a Super Admin / Admin changes it (employee form).
 */
@Injectable({ providedIn: 'root' })
export class StaffProfileService {
  private readonly apiUrl = environment.apiBase;
  private last?: StaffDateOfBirthStatus;

  constructor(private http: HttpClient) {}

  /** Fresh status from the server (cached for per-navigation checks). */
  getDateOfBirthStatus(): Observable<StaffDateOfBirthStatus> {
    return this.http
      .get<{ data: StaffDateOfBirthStatus }>(`${this.apiUrl}/board/users/me/date-of-birth`)
      .pipe(
        map((res) => res.data),
        tap((status) => (this.last = status))
      );
  }

  get cachedStatus(): StaffDateOfBirthStatus | undefined {
    return this.last;
  }

  saveDateOfBirth(dateOfBirth: string): Observable<{ dateOfBirth: string }> {
    return this.http
      .post<{ data: { dateOfBirth: string } }>(`${this.apiUrl}/board/users/me/date-of-birth`, {
        dateOfBirth
      })
      .pipe(
        map((res) => res.data),
        tap((res) => (this.last = { required: false, dateOfBirth: res.dateOfBirth }))
      );
  }
}
